import api from "../lib/axios";

export const notificationService = {
  setFcmToken: async (data: { device_token: string }) => {
    const response = await api.post("/admin/notifications/fcm-token", data);
    return response.data;
  },
  list: async (params?: { page?: number; limit?: number }) => {
    const response = await api.get("/admin/notifications", { params });
    return response.data;
  },
  markAsRead: async (id: number) => {
    const response = await api.patch(`/admin/notifications/${id}/read`);
    return response.data;
  },
};
